import React from "react";

export default function ImpactSection() {
  return (
    <section className="py-10 px-4 bg-white">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="text-center mb-6">
          <span className="inline-block bg-rose-50 text-rose-500 text-xs font-bold px-4 py-1.5 rounded-full mb-3">
            PICK UP
          </span>
          <h2 className="text-xl font-bold text-gray-800 mb-2">
            LoveNavi 今すぐ💨やれる！爆速ハメアプリ３選
          </h2>
          <p className="text-gray-500 text-xs leading-relaxed">
            脅威の満足度！脅威のマッチング率で昇天確定
          </p>
        </div>

        {/* Image cards */}
        <div className="flex gap-3">
          {/* Male card */}
          <div className="flex-1 relative rounded-2xl overflow-hidden shadow-lg h-64">
            <img
              src="https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/049708534b6c27e5985cbaf5a775741f.jpeg"
              alt="男性イメージ"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src =
                  "https://via.placeholder.com/380x480?text=Male+Image";
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-3 left-3 right-3">
              <span
                className="text-white text-xs font-bold bg-red-600/90 backdrop-blur-sm px-3 py-1.5 rounded-full block text-center"
                style={{ animation: 'blink 0.8s step-start infinite' }}
              >
                只今女性会員爆増中！
              </span>
            </div>
          </div>

          {/* Female card */}
          <div className="flex-1 relative rounded-2xl overflow-hidden shadow-lg h-64">
            <img
              src="https://static.readdy.ai/image/fadcb95cbb570992388b73198b4e8870/fa7c0be526b528b321731eb9d1dbb3f4.jpeg"
              alt="女性イメージ"
              className="w-full h-full object-cover object-top"
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src =
                  "https://via.placeholder.com/380x480?text=Female+Image";
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <div className="absolute bottom-3 left-3 right-3">
              <span
                className="text-white text-xs font-bold bg-red-600/90 backdrop-blur-sm px-3 py-1.5 rounded-full block text-center"
                style={{ animation: 'blink 0.8s step-start infinite' }}
              >
                只今女性会員爆増中！
              </span>
            </div>
          </div>
        </div>

        {/* Statistics */}
        <div className="mt-6 flex items-center justify-center gap-6 text-center">
          <div>
            <p className="text-2xl font-bold text-rose-500">300万+</p>
            <p className="text-xs text-gray-500 mt-0.5">累計ユーザー</p>
          </div>

          <div className="w-px h-8 bg-gray-200" />

          <div>
            <p className="text-2xl font-bold text-orange-500">98%</p>
            <p className="text-xs text-gray-500 mt-0.5">満足度</p>
          </div>

          <div className="w-px h-8 bg-gray-200" />

          <div>
            <p className="text-2xl font-bold text-pink-500">50万+</p>
            <p className="text-xs text-gray-500 mt-0.5">カップル成立</p>
          </div>
        </div>
      </div>
    </section>
  );
}
